<template>
    <div class="container">
      <!-- 三个查询条件 -->
      <div style="display: flex; flex-wrap: nowrap; height: 45px; margin-top: 5px;">
        <div>
          <el-form :inline="true"  class="demo-form-inline" label-width="160px" style="display: flex; flex-wrap: nowrap;">
            <el-form-item label="条件查询：" style="display: flex;">
              <el-input clearable v-model="condition" placeholder="物料编码或物料名称" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item  style="display: flex; flex-wrap: nowrap; min-width: 183px;">
              <el-button type="primary" @click="submit" style="flex-wrap: nowrap; ">查询</el-button>
              <!-- <el-button type="danger" @click="exportExcel" style="flex-wrap: nowrap; ">导出excel</el-button> -->
            </el-form-item>
          </el-form>
      </div>
       
      </div>
  
      <!-- 表格 -->
      <div style="padding-bottom: 2px;">
        <el-table :data="list"   height="250"  :cell-style="rowStyle"
        id="tableId" ref="tableId"
        min-width="30px" style="font-size: calc(16vw * 100 / 1920); flex-wrap: nowrap; min-height: 780px; margin-top: 0px;">
        <el-table-column
          label="序号"
          type="index"
          width="60"
          align="center">
        </el-table-column>  
          <el-table-column label="物料编码" width="auto" align="center">
            <template slot-scope="scope">
              <i class="iconfont icon-bianmubianma"></i>
              <span style="margin-left: 10px" v-copy.dblclick>{{ scope.row.wlcode }}</span>
            </template>
          </el-table-column>
          <el-table-column label="物料名称" width="auto" align="center">
            <template slot-scope="scope">
              <i class="iconfont icon-mingcheng"></i>
              <span style="margin-left: 10px" v-copy.dblclick>{{ scope.row.wlDes }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
  
      <div>
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 50, 100]"
        :page-size="10"
        style="padding: 10px;"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'viewMaterial',
    data() {
      return {
        condition:'',
        // 
        // 数据存放
        list: [],
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示的数据量
        total: 0, // 总数据量
      }
    },
    methods: {
      rowStyle() {
        return "text-align:center";
      },
      submit(){
        this.getData(1);
      },
       // 页数发生改变时
       handleCurrentChange(val) {
        this.currentPage = val;
        this.getData(this.currentPage);
      },
      handleSizeChange(val){
        this.pageSize = val
        this.getData(this.currentPage)
       
      },
      getData(page) {
        this.currentPage=page;
        this.$api.getGoodsInfo( this.currentPage,this.pageSize, {info:this.condition}).then(res =>{
            this.total = res.total;
            this.list = res.records;
        })
    },
    },
  }
  </script>
  
  <style lang="less" scoped>
  
  .icon1 {
    font-size: 26px;
    text-align: center;
  }
  /deep/ .el-pagination{
   margin-top: 0 !important;
   padding: 0 !important;
}
  </style>